module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.slides) ? _c('div', {
    staticClass: "goldBg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "carousel"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.slides), function(slide, index) {
    return _c('slide', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.currentSlide),
        expression: "index === currentSlide"
      }],
      key: index,
      class: index === _vm.currentSlide ? 'active' : '',
      attrs: {
        "slide": slide,
        "index": index
      }
    })
  })), _vm._v(" "), (_vm.slides.length > 1) ? _c('div', {
    staticClass: "pager"
  }, _vm._l((_vm.slides), function(slide, index) {
    return _c('button', {
      key: index,
      staticClass: "btn btn-sm",
      class: index === _vm.currentSlide ? 'active' : '',
      on: {
        "click": function($event) {
          _vm.goToThisSlide(index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(index) + "\n        ")])
  })) : _vm._e(), _vm._v(" "), (_vm.slides.length > 1) ? _c('div', {
    staticClass: "controls"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.prevSlide()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/PFK_Arrow_Carousel_Left.svg"),
      "width": "40",
      "height": "40"
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.nextSlide()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/PFK_Arrow_Carousel_Right.svg"),
      "width": "40",
      "height": "40"
    }
  })])]) : _vm._e()], 1)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-47cd9470!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Carousel.vue
// module id = 383
// module chunks = 2